module.exports = __webpack_public_path__ + "media/images/users/user-9-81cac6141010899738d1507be36aa9a7.jpg";